import { atom } from "nanostores";

// panels
export const $isPanelOpen = atom(false);
